import * as React from 'react';
const MealsIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <path
      stroke={props.color || '#FFFFFF8C'}
      strokeLinecap="round"
      strokeOpacity={0.55}
      strokeWidth={1.333}
      d="M2 4h12M2 8h12M2 12h12"
      opacity={0.7}
    />
  </svg>
);
export default MealsIcon;
